<template>
<div>
    <form-withdata ref="form"  :isEdit="isEdit" :id="id" @submitSuccess="submitSuccess" @saveLoad="saveLoad" @submitLoad="submitLoad"></form-withdata>
    <div class="button-div">
        <el-button type="primary" @click="submit" :loading="submitLoading">提交</el-button>
        <el-button type="primary" plain @click="save" :loading="saveLoading">保存</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
</div>
</template>
<script>
import formWithdata from './withData'
export default {
  components: {
    formWithdata
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      submitLoading: false,
      saveLoading: false
    }
  },
  methods: {
    saveLoad () {
      this.saveLoading = true
    },
    submitLoad () {
      this.submitLoading = true
    },
    submitSuccess (val) {
      this.saveLoading = false
      this.submitLoading = false
    },
    submit () {
      this.$refs.form.submit()
    },
    save () {
      this.$refs.form.submit('save')
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>
<style lang="less">
</style>
